import { ChannelFilters, ChannelOptions, ChannelSort } from 'stream-chat';
import { StreamType } from '@components/chat/shared/useStreamChat';
import { ChannelType } from './constants';

export default function getChannelListFilters({ userId, limit }: { userId?: string; limit?: number }): {
  filters?: ChannelFilters<StreamType>;
  sort?: ChannelSort<StreamType>;
  options?: ChannelOptions;
} {
  return {
    filters: {
      type: { $in: Object.values(ChannelType) },
      members: { $in: [userId] },
      // This ensures only channels with more than 1 member are displayed and hides channels with only 1 member left
      member_count: { $gt: 1 },
      // This is an arbitrary date before the release of the attendee messaging feature,
      // to ensure all non-empty channels the attendee is in are returned.
      last_message_at: { $gte: '2020-10-10T16:01:49.27673Z' }
    },
    sort: {
      last_message_at: -1,
      updated_at: -1
    },
    options: {
      state: true,
      presence: true,
      limit
    }
  };
}
